import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Breadcrumb as CBreadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { getValidUrl } from '@/utils'

interface Props {
  currentItem: string
}

const Breadcrumb = ({ currentItem }: Props) => {
  const { t, i18n } = useTranslation()
  return (
    <CBreadcrumb
      mx="auto"
      paddingBottom="24px"
      borderBottom="1px solid #9EA1A2"
      fontSize="14px"
      separator={<ChevronRightIcon color="#9EA1A2" />}
    >
      <BreadcrumbItem>
        <BreadcrumbLink
          color="#9EA1A2"
          href={getValidUrl('/glossary', i18n.language)}
        >
          {t('article.breadcrumbMainTitle')}
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbItem isCurrentPage>
        <BreadcrumbLink
          color="#0058AA"
          dangerouslySetInnerHTML={{ __html: currentItem.toUpperCase() }}
        />
      </BreadcrumbItem>
    </CBreadcrumb>
  )
}

export default Breadcrumb
